import { render, staticRenderFns } from "./GroupAdminList.vue?vue&type=template&id=7468e10c"
import script from "./GroupAdminList.vue?vue&type=script&lang=js"
export * from "./GroupAdminList.vue?vue&type=script&lang=js"
import style0 from "./GroupAdminList.vue?vue&type=style&index=0&id=7468e10c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports